import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Skeleton,
  Text
} from '@chakra-ui/react';
import _ from 'lodash';
import React, {useEffect, useState} from 'react';
import {MdChevronLeft} from 'react-icons/md';
import {useDispatch, useSelector} from 'react-redux';
import BackToTopButton from '../../components/BackToTopButton';
import {useInAppTooltip} from '../../hooks/useInAppTooltip';
import {
  folderClose,
  pinsFolderRequest,
  pinsListFolderResultsClear,
  pinsListFolderSortSet,
} from '../../reducers/pinsReducer';
import PermissionBadge from './PermissionBadge';
import PinFolderOptionsMenu from './PinFolderOptionsMenu';
import PinsList from './PinsList';
import PinsListController from './PinsListController';
import PinsListFilters from './PinsListFilters';

const PinFolderModal = () => {
  const folderOpened = useSelector(s => s.pins.folderOpened);
  const dispatch = useDispatch();

  const isPlaceIdsSearch = useSelector(s => s.pins.pinsListSearch.ids); // could be a cluster or single 3d place


  const [folderOpenedDelayed, setFolderOpenedDelayed] = useState(folderOpened);

  useEffect(() => {
    setTimeout(() => setFolderOpenedDelayed(folderOpened), 333);
  }, [folderOpened]);


  const [scrollableRef, setScrollableRef] = useState(null);
  const worldId = useSelector(s => s.inApp.world._id);

  const {
    featuredIds,
    featuredImageUrl,
    isOwnedByUser,
    isSolo,
    label,
    ownerAlias,
    presetName,
    sharedInWorld,
  } = folderOpened || {};

  const isFeaturedList = !_.isEmpty(featuredIds);


  const backButtonTooltipProps = useInAppTooltip(isFeaturedList ? 'Back to Places' : 'Back to Lists');


  const showOptionsMenu = isOwnedByUser && !presetName;


  return (
    <Modal
      // blockScrollOnMount={false}
      isOpen={!!folderOpened && !isPlaceIdsSearch}
      onClose={() => {
        dispatch(folderClose());
      }}
      size="full"
      scrollBehavior="inside"
      // finalFocusRef={} // The ref of element to receive focus when the modal closes.
    >
      <ModalOverlay/>

      <ModalContent
        bg="bg"
      >
        <ModalHeader
          display="flex"
          flexDirection="column"
          p={0}
          bgGradient={featuredImageUrl ? 'linear(180deg, #0008, #0000)' : undefined}
        >
          <Flex justifyContent="space-between" p={4} gap={4}>
            <PermissionBadge
              isOwnedByUser={isOwnedByUser}
              isPrivate={isSolo}
              isShared={sharedInWorld === worldId}
              ownerAlias={ownerAlias}
              size="1.5em"
            />

            <Text
              align="center"
              color={featuredImageUrl ? 'white' : undefined}
              fontWeight={isFeaturedList ? 'bold' : 'normal'}
              fontSize={isFeaturedList ? '3xl' : '2xl'}
            >{label}</Text>

            {showOptionsMenu ? <PinFolderOptionsMenu folder={folderOpened}/> : <Box></Box>}
          </Flex>

          <PinsListFilters
            contentLeft={
              <ModalCloseButton
                bg="white"
                borderRadius="xl"
                fontSize="1em"
                height="40px"
                position="relative"
                right="unset"
                top="unset"
                width="3.5em"

                {...{
                  ...backButtonTooltipProps,

                  color: 'black24',

                  _hover: {
                    filter: `brightness(0.8)`,
                    shadow: 'none',

                    _disabled: {
                      bg: 'inactiveGrey',
                    }
                  },
                  _focus: {
                    shadow: 'none',
                  },
                  _focusVisible: {
                    shadow: 'none',
                  },
                }}
              >
                <MdChevronLeft/>
                <Text fontSize="0.75em">Back</Text>
              </ModalCloseButton>
            }
            isContentLeftRightFixedSize={false}
            onSortSet={pinsListFolderSortSet}
            paddingX={4}
            paddingTop={4}
            placeholderText={`Search in ${isFeaturedList ? 'Featured ' : ''}List: ${folderOpened && folderOpened.label}`}
            stateKey="pinsListFolder"
            textInputStateKey="txtInputPlacesInList"
            top={0}
          />

          {featuredImageUrl && (
            <Image
              top="-20%"
              left={0}
              fit="cover"
              w="full"
              position="absolute"
              src={featuredImageUrl}
              zIndex={-1}
              // opacity={0.5}
            />
          )}
        </ModalHeader>


        <ModalBody
          bg="bg"
          p={0}
          ref={el => {
            setScrollableRef(el);
          }}
          sx={{
            '&::-webkit-scrollbar': {
              width: '8px',
              borderRadius: '8px',
              backgroundColor: `rgba(0, 0, 0, 0.07)`,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: `rgba(0, 0, 0, 0.07)`,
            },
          }}
        >
          <Skeleton isLoaded={!!folderOpenedDelayed}>
            {!!folderOpenedDelayed && ( // delay requesting data
              <PinsListController
                onClearPins={pinsListFolderResultsClear}
                onRequestPins={pinsFolderRequest}
                stateKey="pinsListFolder"
                textInputStateKey="txtInputPlacesInList"
              />
            )}

            <PinsList
              bgGradient={featuredImageUrl ? `linear(135deg, #6BA9B0, #8D66CC)` : undefined}
              borderTopRadius={0}
              columns={2}
              onRequestPins={pinsFolderRequest}
              stateKey="pinsListFolder"
              textInputStateKey="txtInputPlacesInList"
            />
          </Skeleton>
        </ModalBody>

        {/*<DrawerFooter>*/}
        {/*</DrawerFooter>*/}

        {scrollableRef && <BackToTopButton element={scrollableRef}/>}

      </ModalContent>
    </Modal>
  );


};

export default PinFolderModal;
